<template>
    <div>
      <el-container>
        <el-header>
          <el-menu style="margin:  0 auto; width: 80%" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">登录</el-menu-item>
            <el-menu-item index="2">首页</el-menu-item>
            <el-menu-item index="3">发送记录</el-menu-item>
          </el-menu>
        </el-header>
        <el-main>
          <router-view ></router-view>
        </el-main>
      </el-container>
    </div>
</template>

<script>
    export default {
        name: "AdmMain",

      data(){
          return{
            activeIndex:'1',
          }
      },
      methods:{
        handleSelect:function (index) {
          switch (index) {
            case "1":
              this.$router.replace({name: 'AdmLogin'});
              break;
            case "2":
              this.$router.replace({name: 'AdmAccess'});
              break;
            case "3":
              this.$router.replace({name: 'AdmSmsLog'});
              break;
          }
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/admin/AdmMain.vue